import { Directive, Inject, HostListener, ElementRef, Optional, DOCUMENT } from '@angular/core';

import { NgxMaskDirective, NgxMaskService  } from 'ngx-mask';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pcgPhone]',
    providers: [NgxMaskService],
    standalone: false
})
export class PhoneDirective extends NgxMaskDirective {
	constructor(@Inject(DOCUMENT) document: any, maskService: NgxMaskService,
		private elRef: ElementRef, @Optional() private control: NgControl) {

		super();
		this.patterns = {
			'0': {
				pattern: new RegExp('\\d'),
			},
			'9': {
				pattern: new RegExp('\\d'),
				optional: true
			},
			'-': { pattern: new RegExp('-') },
			' ': { pattern: new RegExp(' ') },
			')': { pattern: new RegExp('\\)') },
			'(': { pattern: new RegExp('\\(') },
		};
		this.specialCharacters = ['(', ')', '-', ' '];
		this.maskExpression = '(000) 000-0000';
		this.dropSpecialCharacters = false;
	}

	@HostListener('keyup')
	keyEvent() {
		if (this.control) {
			this.control?.control?.setValue(this.elRef.nativeElement.value);
		}
	}

	@HostListener('change')
	changeEvent() {
		if (this.control) {
			this.control?.control?.setValue(this.elRef.nativeElement.value);
		}
	}
}
